import { IPageName } from '../../common/types/apiSchema';
import { PathMap } from './paths';

/**
 * Localised URLs for Germany
 */
export const DePaths: PathMap = {
  [IPageName.collections]: ['/:filterslug/filter'],
  [IPageName.bookingsPage]: ['/buchungen'],
  [IPageName.bookingDetailsPage]: ['/buchungen/:bookingId/details'],
  [IPageName.cancellationPage]: ['/buchungen/:bookingId/cancellation'],
};
